// Dayjs plugin setup MUST run before any code that uses dayjs.tz/utc.
// Keep these two imports at the very top of the bootstrap module.
import '@ant-design/v5-patch-for-react-19';
import './dayjs-setup';

import { Suspense } from 'react';
import * as ReactDOMClient from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ITDProvider, Spin } from '@inntechcorp/it-design';
import lazy from "@loadable/component";
import { SkeletonTheme } from "react-loading-skeleton";
// import Cookies from 'js-cookie';

import { BackOfficeProvider } from 'Context/BackOfficeContext';
import { BackofficeSocketProvider } from 'Context/BackofficeSocketContext';
import { checkBillingAccess, checkCrmSegmentAccess } from 'Utils/featureFlags';

// Check feature-flag access codes in the URL on app boot.
checkBillingAccess();
checkCrmSegmentAccess();

import { DefaultSpinner, LoadingDefaultHeight, SpinWrapper } from "Styles/global.styled";

import "@inntechcorp/it-design/dist/global.css";
import "react-loading-skeleton/dist/skeleton.css";

import 'Styles/global.scss';

// import tr from "@inntechcorp/it-design/dist/locales/en/itd.json";
// import en from "@inntechcorp/it-design/dist/locales/en/itd.json";

import './styles/itd/itd-modal-styles.scss';

const App = lazy(() => import("Pages/app"));

function renderDOM() {

  const rootElement = document.getElementById("app");
  const root        = rootElement && ReactDOMClient.createRoot(rootElement);

  const suspense = (
    <LoadingDefaultHeight $minHeight="100vh">
      <DefaultSpinner>
        <SpinWrapper>
          <Spin />
        </SpinWrapper>
      </DefaultSpinner>
    </LoadingDefaultHeight>
  );

  return (
      
    root?.render(
  
      <Suspense fallback={suspense}>

        <BrowserRouter>
          <SkeletonTheme
            baseColor       = "#f9f9f9"
            highlightColor  = "#ffffff"
          >
            <ITDProvider theme="light">
              <BackOfficeProvider>
                <BackofficeSocketProvider>
                  <App />
                </BackofficeSocketProvider>
              </BackOfficeProvider>
            </ITDProvider>
          </SkeletonTheme>
        </BrowserRouter>

      </Suspense>

    )

  )

}

renderDOM();